module.exports = __webpack_public_path__ + "./img/DestacadosInicio.ae225c0925ad4689b868dae3a2f1cb7e.png";


//////////////////
// WEBPACK FOOTER
// ./public/img/Help/DestacadosInicio.png
// module id = ./public/img/Help/DestacadosInicio.png
// module chunks = 0